export default "__VITE_ASSET__COcqW3$t__"